import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_positions': '[BuildingPositionInputType]',
};

export default gql(`
	mutation building_positions( ${ HelperGraphql.createFields( fields ) } ) {
	    building_positions( ${ HelperGraphql.createVariables( fields ) } ) {
	       guid
	       position
	    }
	}
`);

